import { Container, Title, Button, TipsBar } from '@/components'

import useClickWithScroll from '@/utils/browser/useClickWithScroll'

import styles from './styles.module.scss'
import Image from 'next/image'
import nutriImageUrl from '/public/images/nutritionist/time.webp'
import { ITEMS } from './constants'

const NutritionistTime = () => {
  const { isHomePage, onClickItem } = useClickWithScroll()

  return (
    <>
      <TipsBar
        text={'TREINOS COM RESULTADOS EM POUCAS SEMANAS • COMECE AGORA!'}
      />
      <section className={`fgt-section ${styles.nutritionist}`}>
        <Container classname={styles.nutritionist__container}>
          <Title Tag="h2" alignText="center">
            <span>Time de nutris</span> para ajudar no seu objetivo
          </Title>
          <p className="fgt-subtitle">
            Cardápios personalizados para maximizar os resultados dos seus
            treinos e garantir sua transformação, tudo sem sair de casa!
          </p>

          <div className={styles.nutritionist__content}>
            <Image
              className={styles['nutritionist__content--image']}
              src={nutriImageUrl}
              alt="Time de nutricionistas"
              width={545}
              height={363}
            />
            <div className={styles.nutritionist__topics}>
              {ITEMS.map((item, index) => {
                return (
                  <div className={styles.nutritionist__item} key={index}>
                    <div className={styles['nutritionist__item--icon']}>
                      <Image
                        src={item.iconUrl}
                        alt={item.text}
                        width={24}
                        height={24}
                      />
                    </div>
                    <p className={styles['nutritionist__item--text']}>
                      {item.text}
                    </p>
                  </div>
                )
              })}
              <div className="fgt-section__action">
                <Button
                  id="btn-section-nutritionist"
                  variant="primary"
                  className={'fgt-section__action--button'}
                  onClick={() => {
                    onClickItem('comparePlans')
                  }}
                >
                  QUERO EXPERIMENTAR 7 DIAS
                </Button>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  )
}

export default NutritionistTime
